import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'


export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectValidationMessageList = state => {
    return selectOwnState(state).validationMessageList
}

export const selectCommentText = state => {
    return selectOwnState(state).commentText
}

export const selectProcessFlowVisible = (state) => {
    return selectOwnState(state).processFlowVisible
}

export const selectBeamProcessState = state => {
    return selectOwnState(state).beamProcessState
}

export const selectProcessInstance = (state) => {
    return selectOwnState(state).processInstance
}

export const selectProcessInstanceId = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.id : null
}

export const selectCurrentTaskName = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.currentTaskName : null
}

export const selectProcessContext = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.context : null
}

export const selectProcessStateHistoryList = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.processStateHistoryList : null
}


export const selectProcessLogList = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.processLogList : null
}

export const selectCommentList = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.processCommentList : null
}

export const selectProcessTaskList = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.processTaskList : []
}
export const selectProcessObjectDetail = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.objectDetail : null
}
export const selectProcessVoucherList = state => {
    const processObjectDetail = selectProcessObjectDetail(state)
    const customer = processObjectDetail ? processObjectDetail.customer : null
    const voucherList = customer ? customer.voucherList : []
    return voucherList || []
}
export const selectOpenTask = state => {
    const taskList = selectProcessTaskList(state)
    for (let index = 0; index < taskList.length; index++) {
        const task = taskList[index]
        if (task.status === 'open' || task.status === 'pending') {
            return task
        }
    }
    return null
}

export const selectVIPStatus = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? !!processInstance.vip : false
}

export const selectRushStatus = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? !!processInstance.rush : false
}


export const selectAvailableStateList = state => {
    const processInstance = selectProcessInstance(state)
    if (!processInstance || !processInstance.processVersion || !processInstance.processVersion.stateList) {
        return []
    }
    const stateList = processInstance.processVersion.stateList

    stateList.sort((a, b) => {
        if (a.name < b.name) {
            return -1
        }

        if (a.name > b.name) {
            return 1
        }
        return 0
    })

    return stateList
}

export const selectCurrentState = state => {
    const processInstance = selectProcessInstance(state)
    return processInstance ? processInstance.currentState : null
}

export const selectAvailableTransitionList = state => {
    const currentState = selectCurrentState(state)
    if (!currentState) {
        return null
    }
    return currentState.transitionList.filter(transition => {
        return !!transition.eventName
    })
}

export const selectFreshSalesDealOwner = state => {
    const processInstance = selectProcessInstance(state)

    if (!processInstance.objectDetail){

        return null;
    }

    const freshSalesDealOwner = processInstance.objectDetail.freshSalesDealOwner

    return freshSalesDealOwner ? freshSalesDealOwner : null
}

export const selectFreshSalesCalendlyLink = state => {
    const processInstance = selectProcessInstance(state)

    if (!processInstance.objectDetail){

        return null;
    }

    const freshSalesCalendlyLink = processInstance.objectDetail.freshSalesCalendlyLink

    return freshSalesCalendlyLink ? freshSalesCalendlyLink : null
}



// WEBPACK FOOTER //
// ./src/modules/process/state/instance-detail/selector.js